module.exports = __webpack_public_path__ + "a0ae6562630b4539ff6fc079f5e37286.png";